import { useMemo, useState } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import EVNHeader from '../../components/EVN/EVNHeader';
import EVNFilters from '../../components/EVN/EVNFilters';
import EVNTable from '../../components/EVN/EVNTable';
import EVNStyles from './EVN.styles';
import CenteredLoader from '../../../../components/loaders/PageLoader';

import { useEVNs } from '../../hooks/useEVNs';
import { mapEvnsToRows, getUniqueEvnOptions, getUniqueTrainNumberOptions } from '../../utils/evn.mapping';

import { useCrumb } from '../../../../layouts/TrailProvider';

export default function EVN() {
  const { isSidebarExpanded } = useOutletContext();
  const navigate = useNavigate();

  useCrumb('EVNs', '/home/evns');

  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [filters, setFilters] = useState({ evn: [], trainNumber: [] });

  const { data: rows, loading } = useEVNs(mapEvnsToRows);

  const evnOptions = useMemo(() => getUniqueEvnOptions(rows), [rows]);
  const trainNumberOptions = useMemo(() => getUniqueTrainNumberOptions(rows), [rows]);

  const filteredRows = useMemo(() => {
    return rows.filter(r => {
      if (filters.evn.length && !filters.evn.includes(r.evn)) return false;
      if (filters.trainNumber.length && !filters.trainNumber.includes(r.trainNumber)) return false;

      if (dateRange.start && dateRange.end) {
        const d = new Date(r.createdOn);
        if (isFinite(d) && (d < new Date(dateRange.start) || d > new Date(dateRange.end))) return false;
      }

      if (searchQuery) {
        const q = searchQuery.toLowerCase();
        const hay = `${r.evn} ${r.trainNumber}`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });
  }, [rows, filters, dateRange, searchQuery]);

  const handleAdd = () => navigate('/home/create-config');

  return (
    <Box
      sx={{
        ...EVNStyles.fileContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <CenteredLoader />
      ) : (
        <>
          <EVNHeader
            title="EVNs"
            onSearch={() => {}}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />

          <EVNFilters
            filters={filters}
            setFilters={setFilters}
            dateRange={dateRange}
            setDateRange={setDateRange}
            evnOptions={evnOptions}
            trainNumberOptions={trainNumberOptions}
            onAdd={handleAdd}
          />

          <EVNTable rows={filteredRows} />
        </>
      )}
    </Box>
  );
}
